import styled from 'styled-components'

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 252px;
`

export const LoadingOverlay = styled.div`
  display: ${ (props) => (props.showOverlay ? 'block' : 'none') };
`
